<div class="gridList" (window:resize)="onResize($event)">
	@for (item of listaItens | paginate: {itemsPerPage: pagesize, currentPage: page, totalItems: ids.length}; track $index) {
	<div class="listaItens">
		<app-item-pesquisa class="itemPesquisa" [itemPesquisa]="item"
			[temSimilares]="getSimilares(item.itemDetalhado)" [quantidadeItem]="getQuantidade(item.idItem) > 0 ? getQuantidade(item.idItem) : (item.itemDetalhado?.itemPedido?.quantidade ?? 0)"
			[valorTotalItem]="getTotal(item.idItem)" [valorLiquido]="item.vl_unitario_liquido"
			[item]="getItemDetalhado(item)" [fichaTecnica]="getFichaTecnica(item.itemDetalhado)"
			[temEstoque]="getQtAtual(item.itemDetalhado)" [itemPedido]="getItemDetalhado(item).itemPedido"
			[exibeDesconto]="getExibeDesconto()" [exibeEstoque]="getExibeEstoque()">
		</app-item-pesquisa>
	</div>
	}
</div>
